// extracted by mini-css-extract-plugin
export default {"sectionsList":"Styles_sectionsList__ro7JB","noResult":"Styles_noResult__wbgJ3","slide-in-bottom":"Styles_slide-in-bottom__FLQMh"};